const safeMultiply = (value, multiplier) => parseFloat((value * multiplier).toFixed(2));

const safeSum = (...values) => parseFloat(values.reduce((a, b) => a + b, 0).toFixed(2));

const safeSubtract = (subtractFrom, ...values) =>
  Math.abs(parseFloat(values.reduce((a, b) => a - b, subtractFrom).toFixed(2)));

export { safeMultiply, safeSum, safeSubtract };
